import React, { createContext, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

// Define default metadata values
const defaultMetadata = {
  title: 'Afforda | Credit, Savings, & Benefits',
  description: 'Afforda - Your Financial Wellbeing Partner',
};

// Create a context for metadata
const MetadataContext = createContext<null>(null);

/**
 * MetadataProvider component
 * 
 * This component provides a base Helmet setup with default metadata.
 * Individual pages should use the PageMetadata component to override these values.
 */
export const MetadataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <MetadataContext.Provider value={null}>
      {/* Base Helmet that sets up defaults */}
      <Helmet defaultTitle={defaultMetadata.title}>
        <meta 
          key="description" 
          name="description" 
          content={defaultMetadata.description} 
        />
      </Helmet>
      {children}
    </MetadataContext.Provider>
  );
};

/**
 * This hook is no longer used, but kept for backward compatibility.
 * Use the PageMetadata component directly instead.
 */
export const useMetadata = () => {
  return {
    setMetadata: () => {
      console.warn('useMetadata is deprecated. Use PageMetadata component instead.');
    }
  };
};
